import styles from './FooterCellContent.module.scss';

import { flexRender, Header } from '@tanstack/react-table';
import clsx from 'clsx';

import { getAlignment } from '../../../../utils/alignment';

interface FooterCellContentV8Props {
  header: Header<unknown, unknown>;
  cellProps?: Record<string, number>;
}

export function FooterCellContentV8(props: FooterCellContentV8Props) {
  const { header, cellProps } = props;

  const columnDef = header.column.columnDef;

  const alignment = getAlignment(
    columnDef.alignment ?? columnDef.footerAlignment,
    columnDef.dataType
  );

  const footerContext = {
    ...header.getContext(),
    ...cellProps,
  };

  return (
    <div className={clsx(styles.content, styles[alignment])}>
      {flexRender(columnDef.footer, footerContext)}
    </div>
  );
}
